import { BreifInfluencerV2StatusEnum } from "@entities/brief/lib/constants";
import {
  IBriefInfluencerSearchRequestV2,
  IBriefInfluencerV2,
} from "@shared/lib/types/briefInfluencerV2";

export enum CampaignBriefStage {
  Reviewing = "reviewing",
  Shortlisted = "shortlisted",
  Purchased = "purchased",
}

export type CampaignBriefStageId = `${CampaignBriefStage}`;

export const CAMPAIGN_BRIEF_STAGES: {
  id: CampaignBriefStage;
  step: number;
  label: string;
}[] = [
  { id: CampaignBriefStage.Reviewing, step: 1, label: "Reviewing" },
  { id: CampaignBriefStage.Shortlisted, step: 2, label: "Shortlisted" },
  { id: CampaignBriefStage.Purchased, step: 3, label: "Purchased" },
];

type StageSearchParams = Pick<
  IBriefInfluencerSearchRequestV2,
  "statuses" | "isShortlisted" | "isCreatorDeclined" | "isBrandDeclined"
>;

export function getCampaignBriefStageSearchParams(
  stage: CampaignBriefStage
): StageSearchParams {
  if (stage === CampaignBriefStage.Purchased) {
    return {
      statuses: [BreifInfluencerV2StatusEnum.Purchased],
      isCreatorDeclined: false,
      isBrandDeclined: false,
    };
  }

  return {
    statuses: [
      BreifInfluencerV2StatusEnum.Shortlisted,
      BreifInfluencerV2StatusEnum.Pricing,
    ],
    isShortlisted: stage === CampaignBriefStage.Shortlisted,
  };
}

export function getCreatorShortlistActionMode(
  stage: CampaignBriefStage,
  record: Pick<
    IBriefInfluencerV2,
    "status" | "isCreatorDeclined" | "isBrandDeclined"
  >
): "shortlist" | "unshortlist" | null {
  if (record.isCreatorDeclined || record.isBrandDeclined) {
    return null;
  }
  if (record.status === BreifInfluencerV2StatusEnum.Purchased) {
    return null;
  }
  if (stage === CampaignBriefStage.Reviewing) {
    return "shortlist";
  }
  if (stage === CampaignBriefStage.Shortlisted) {
    return "unshortlist";
  }
  return null;
}
